import { render, staticRenderFns } from "./fireFightingTraningEduYear.vue?vue&type=template&id=6b515bfb"
import script from "./fireFightingTraningEduYear.vue?vue&type=script&lang=js"
export * from "./fireFightingTraningEduYear.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6b515bfb')) {
      api.createRecord('6b515bfb', component.options)
    } else {
      api.reload('6b515bfb', component.options)
    }
    module.hot.accept("./fireFightingTraningEduYear.vue?vue&type=template&id=6b515bfb", function () {
      api.rerender('6b515bfb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/fft/fte/fireFightingTraningEduYear.vue"
export default component.exports